// Plane distances shared by the map validator and layout.ts's walkability rules.
import type { Pt } from './schema.js';

export const distSeg = (px: number, pz: number, [ax, az]: Pt, [bx, bz]: Pt) => {
  const vx = bx - ax, vz = bz - az, t = Math.max(0, Math.min(1, ((px - ax) * vx + (pz - az) * vz) / (vx * vx + vz * vz)));
  return Math.hypot(px - (ax + vx * t), pz - (az + vz * t));
};
export const distPolyline = (px: number, pz: number, pts: Pt[]) => {
  let d = Infinity;
  for (let i = 0; i < pts.length - 1; i++) d = Math.min(d, distSeg(px, pz, pts[i] as Pt, pts[i + 1] as Pt));
  return d;
};
